import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Label,
  Input,
  FormGroup,
  Badge,
  Form,
  Spinner,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardTitle,
  Tooltip,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import {
  GET_CATEGORY_DETAILS,
  GET_LICENSE_REQ_DOC,
  LICENSE_CATEGORY,
} from "../../../constants/ApiPaths";
import { useDispatch, useSelector } from "react-redux";
import {
  ADD_NEW_FIELD,
  DELETE,
  DRAG_DROP,
  ADD_OPTION,
  VALUE_CHANGES,
  OPTION_VALUES,
  OPTION_DELETE,
  ADD_DUPLICATE,
  FORM_DETAILS,
  NEW_FROM,
} from "../../../redux/actions/ActionTypes";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import { getTemplateId } from "../../common/CommonFunctions";
import { IntialType, special } from "../../../redux/store/InitialStore";
import { useSnackbar } from "notistack";
import {
  CustomAlertMessage,
  SingleStringFirstLetterCaps,
} from "../../../functions/CustomFunctions";
import RequiredDocument from "./RequiredDocument";
import YupSchemaCreator from "./YupSchemaCreator";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import FormPreview from "./FormPreview";
import BackButtonSvg from "../../common/BackButtonSvg";
import { Info } from "../../common/Info";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export default function Licensecategories() {
  const { categoryId } = useParams();
  const [activeTab, setActiveTab] = useState("1");
  const [loading, setLoading] = useState(false);
  const history = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [buttonLoading, setbuttonLoading] = useState(false);
  const [tempSatatus, settempSatatus] = useState(false);
  const [catName, setcatName] = useState("");
  const [catOrd, setcatOrd] = useState("");
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const DeleteAgency = useSelector((state) => state.Agencydelete);

  const [previewModal, setPreviewModal] = useState(false);
  const previewtoggle = () => setPreviewModal(!previewModal);
  const [requiredDoc, setRequiredDoc] = useState([]);
  const from = useSelector((state) => state.FormReducer);
  const { formValues = [] } = from;
  const formInitialValues = {};
  formValues.forEach((i) => {
    formInitialValues[i.uniqueId] = i.label; //valuesConfig[QuestionDataTypeID];
  });

  const yupSchema = formValues.reduce(YupSchemaCreator, {});
  const validationSchema = Yup.object().shape(yupSchema);
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const dispatch = useDispatch();
  const {
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    handleBlur,
    errors,
    touched,
  } = useFormik({
    initialValues: formInitialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => CreateCategory(values),
  });
  const CreateCategory = async () => {
    if (DeleteAgency) return;

    const myJSON = JSON.stringify(formValues);
    setbuttonLoading(true);
    const config = {
      method: "POST",
      url: LICENSE_CATEGORY,
      headers: authHeader(),
      data: {
        templateId: getTemplateId(),
        licenseCategoryDetails: [
          {
            categoryId: categoryId,
            categoryName: catName,
            categoryOrder: catOrd,
            categoryPlaceHolder: myJSON,
          },
        ],
      },
    };
    try {
      const response = await API(config);
      const { status,  message } = response.data;
      if (status === "Success") {
        setbuttonLoading(false);
        CustomAlertMessage(message, "success", enqueueSnackbar);
      }
    } catch (error) {
      const { data } = error.response;
      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setbuttonLoading(false);
    }
  };
  //GET_LICENSE_REQ_DOC

  const getRequiredDoc = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_LICENSE_REQ_DOC,
      headers: authHeader(),
      params: {
        categoryId: categoryId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setRequiredDoc(data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const sucesscallback = () => {
    getRequiredDoc();
  };
  const GetCategory = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_CATEGORY_DETAILS,
      headers: authHeader(),
      params: {
        categoryId: categoryId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        const Details = data[0];
        const {
          categoryPlaceHolder,
          categoryName,
          categoryOrder,
          templateActiveStatus,
        } = Details;
        settempSatatus(templateActiveStatus);
        setcatName(categoryName);
        setcatOrd(categoryOrder);
        if (categoryPlaceHolder == null) {
          dispatch({ type: NEW_FROM });
        } else {
          dispatch({
            type: FORM_DETAILS,
            payload: JSON.parse(categoryPlaceHolder),
          });
        }

        // setcategoryDetils(data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const AddDuplicate = (e) => {
    const id = e.currentTarget.dataset.uniqueid;
    const index = e.currentTarget.dataset.index;
    dispatch({
      type: ADD_DUPLICATE,
      id,
      index,
    });
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    GetCategory();
    getRequiredDoc();
  }, []);

  const FormInputChange = (e) => {
    const id = e.currentTarget.dataset.uniqueid;
    const { name, value, checked, type } = e.target;
    setFieldValue(name, value);
    setFieldTouched(name, true);
    dispatch({
      type: VALUE_CHANGES,
      payload: formValues,
      id,
      name,
      value,
      checked,
      Checkedtype: type,
    });
  };

  const handleRemoveClick = (e) => {
    const id = e.currentTarget.dataset.uniqueid;
    const index = e.currentTarget.dataset.index;
    dispatch({
      type: OPTION_DELETE,
      id,
      index,
    });
  };

  const handleAddClick = (e) => {
    const index = e.currentTarget.dataset.index;
    const list = formValues;
    const { options = {} } = list[index];
    list[index] = {
      ...list[index],
      options: [
        ...options,
        { optionUniqueId: Date.now().toString(), label: "", value: "" },
      ],
    };
    dispatch({
      type: ADD_OPTION,
      payload: list,
    });
  };

  const OptionHandle = (e) => {
    const id = e.currentTarget.dataset.uniqueid;
    const index = e.currentTarget.dataset.index;
    const { name, value } = e.target;
    setFieldValue(name, value);
    setFieldTouched(name, true);
    dispatch({
      type: OPTION_VALUES,
      name,
      value,
      index,
      id,
    });
  };

  const Delete = (e) => {
    const ID = e.currentTarget.dataset.uniqueid;
    dispatch({
      type: DELETE,
      payload: ID,
    });
  };

  const AddNew = () => {
    if (DeleteAgency) return;

    dispatch({
      type: ADD_NEW_FIELD,
    });
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      formValues,
      result.source.index,
      result.destination.index
    );
    dispatch({
      type: DRAG_DROP,
      payload: items,
    });
  };


  return (
    <div className="agency-wrapper">
      {loading && <CustomPageLoading />}
      <Container fluid>
        <div className="page-title">
          <h4>Form Creation</h4>

          <span className="badge badge-primary createLicenseStatus">
            {tempSatatus
              ? "This template is Active so you cannot edit this template"
              : "This template is inactive"}
          </span>

          <div className="top-btn">
            <Button color="primary" onClick={back}>
              <BackButtonSvg />
              Back
            </Button>
          </div>
        </div>
        <div>
          <Nav tabs className="mt-4">
            <NavItem>
              <NavLink
                className={{ active: activeTab === "1" }}
                onClick={() => {
                  toggle("1");
                }}
              >
                Create Form
                <Tooltip
                  isOpen={id === "formcreate" && tooltipOpen}
                  target={"formcreate"}
                  toggle={() => tooltiptoggle("formcreate")}
                >
                  Create new form
                </Tooltip>
                <span id={"formcreate"}>
                  <Info />
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={{ active: activeTab === "2" }}
                onClick={() => {
                  toggle("2");
                }}
              >
                Additional Document
                <Tooltip
                  isOpen={id === "additional" && tooltipOpen}
                  target={"additional"}
                  toggle={() => tooltiptoggle("additional")}
                >
                  Include any additional requested documentation
                </Tooltip>
                <span id={"additional"}>
                  <Info />
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Container fluid>
                <Row className="mt-4">
                  <Col md="12">
                    <div className="mb-5 item-center d-flex">
                      <Label className="m-0">
                        <h5 className="m-0">{catName}</h5>
                      </Label>

                      <Button
                        color="primary"
                        className="float-r ml-auto"
                        onClick={previewtoggle}
                      >
                        Preview
                      </Button>
                    </div>

                    <Row>
                      <Col
                        md="12"
                        //  md={{ size: 8, offset: 2 }}
                      >
                        <div className="licenseEditToolScroll">
                          <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="droppable">
                              {(provided) => (
                                <div
                                  {...provided.droppableProps}
                                  ref={provided.innerRef}
                                >
                                  <Form onSubmit={handleSubmit}>
                                    {loading === false ? (
                                      <>
                                        {formValues.map((data, index) => (
                                          <Draggable
                                            key={
                                              !tempSatatus ? data.uniqueId : ""
                                            }
                                            draggableId={
                                              !tempSatatus ? data.uniqueId : ""
                                            }
                                            index={index}
                                          >
                                            {(provided) => (
                                              <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                id={data.uniqueId}
                                                className="licenseEditTool active"
                                              >
                                                <Badge color="danger">
                                                  {index + 1}
                                                </Badge>
                                                <div className="drag">
                                                  <Badge>
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="19"
                                                      height="9"
                                                      viewBox="0 0 19 9"
                                                    >
                                                      <g
                                                        id="drag"
                                                        transform="translate(-52.052 -50)"
                                                      >
                                                        <rect
                                                          id="Rectangle_1130"
                                                          data-name="Rectangle 1130"
                                                          width="3"
                                                          height="3"
                                                          transform="translate(52.052 50)"
                                                          fill="#7a7a7a"
                                                        />
                                                        <rect
                                                          id="Rectangle_1131"
                                                          data-name="Rectangle 1131"
                                                          width="3"
                                                          height="3"
                                                          transform="translate(60.052 50)"
                                                          fill="#7a7a7a"
                                                        />
                                                        <rect
                                                          id="Rectangle_1132"
                                                          data-name="Rectangle 1132"
                                                          width="3"
                                                          height="3"
                                                          transform="translate(68.052 50)"
                                                          fill="#7a7a7a"
                                                        />
                                                        <rect
                                                          id="Rectangle_1133"
                                                          data-name="Rectangle 1133"
                                                          width="3"
                                                          height="3"
                                                          transform="translate(52.052 56)"
                                                          fill="#7a7a7a"
                                                        />
                                                        <rect
                                                          id="Rectangle_1134"
                                                          data-name="Rectangle 1134"
                                                          width="3"
                                                          height="3"
                                                          transform="translate(60.052 56)"
                                                          fill="#7a7a7a"
                                                        />
                                                        <rect
                                                          id="Rectangle_1135"
                                                          data-name="Rectangle 1135"
                                                          width="3"
                                                          height="3"
                                                          transform="translate(68.052 56)"
                                                          fill="#7a7a7a"
                                                        />
                                                      </g>
                                                    </svg>
                                                  </Badge>
                                                </div>

                                                <Row>
                                                  <Col md="7">
                                                    <FormGroup>
                                                      <Input
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        data-uniqueid={
                                                          data.uniqueId
                                                        }
                                                        invalid={
                                                          errors.hasOwnProperty(
                                                            data.uniqueId
                                                          ) &&
                                                          errors[
                                                            data.uniqueId
                                                          ] &&
                                                          touched.hasOwnProperty(
                                                            data.uniqueId
                                                          )
                                                        }
                                                        name={data.uniqueId}
                                                        value={SingleStringFirstLetterCaps(
                                                          data.label
                                                        )}
                                                        data-index={index}
                                                        onChange={
                                                          FormInputChange
                                                        }
                                                        id="exampleEmail"
                                                        placeholder="Enter Label Name"
                                                      />
                                                      {touched.hasOwnProperty(
                                                        data.uniqueId
                                                      ) &&
                                                      errors.hasOwnProperty(
                                                        data.uniqueId
                                                      )
                                                        ? errors.hasOwnProperty(
                                                            data.uniqueId
                                                          )
                                                        : ""}
                                                      {[
                                                        "radio",
                                                        "checkbox",
                                                        "select",
                                                        "date",
                                                        "time",
                                                      ].includes(data.type) ? (
                                                        ""
                                                      ) : (
                                                        <Input
                                                          className="placeholder-control"
                                                          data-uniqueid={
                                                            data.uniqueId
                                                          }
                                                          onChange={
                                                            FormInputChange
                                                          }
                                                          name="placeholder"
                                                          value={SingleStringFirstLetterCaps(
                                                            data.placeholder
                                                          )}
                                                          type="text"
                                                          placeholder="Enter Description"
                                                        />
                                                      )}
                                                    </FormGroup>

                                                    {[
                                                      "radio",
                                                      "checkbox",
                                                      "select",
                                                    ].includes(data.type) ? (
                                                      <>
                                                        {data.options.map(
                                                          (opt, index) => (
                                                            <div className="multiChoice">
                                                              {/* <div className="drag">
                  <Badge>
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="19" viewBox="0 0 9 19">
                  <g id="dvf" transform="translate(-50 71.052) rotate(-90)">
                  <rect id="Rectangle_1130" data-name="Rectangle 1130" width="3" height="3" transform="translate(52.052 50)" fill="#7a7a7a"/>
                  <rect id="Rectangle_1131" data-name="Rectangle 1131" width="3" height="3" transform="translate(60.052 50)" fill="#7a7a7a"/>
                  <rect id="Rectangle_1132" data-name="Rectangle 1132" width="3" height="3" transform="translate(68.052 50)" fill="#7a7a7a"/>
                  <rect id="Rectangle_1133" data-name="Rectangle 1133" width="3" height="3" transform="translate(52.052 56)" fill="#7a7a7a"/>
                  <rect id="Rectangle_1134" data-name="Rectangle 1134" width="3" height="3" transform="translate(60.052 56)" fill="#7a7a7a"/>
                  <rect id="Rectangle_1135" data-name="Rectangle 1135" width="3" height="3" transform="translate(68.052 56)" fill="#7a7a7a"/>
                  </g>
                  </svg>
                  </Badge >
                </div> */}

                                                              <div className="box">
                                                                <Row>
                                                                  {/* <Col>
                                                                    <Input
                                                                      name="label"
                                                                      placeholder="Enter Label "
                                                                      data-uniqueid={
                                                                        data.uniqueId
                                                                      }
                                                                      data-index={
                                                                        index
                                                                      }
                                                                      value={
                                                                        opt.label
                                                                      }
                                                                      onChange={
                                                                        OptionHandle
                                                                      }
                                                                    />
                                                                  </Col> */}
                                                                  <Col>
                                                                    <Input
                                                                      className="ml10"
                                                                      name="value"
                                                                      placeholder="Enter Value"
                                                                      data-index={
                                                                        index
                                                                      }
                                                                      data-uniqueid={
                                                                        data.uniqueId
                                                                      }
                                                                      value={
                                                                        opt.value
                                                                      }
                                                                      onChange={
                                                                        OptionHandle
                                                                      }
                                                                    />
                                                                  </Col>
                                                                </Row>
                                                              </div>

                                                              {data.options
                                                                .length !==
                                                                1 && (
                                                                <Button
                                                                  data-uniqueid={
                                                                    data.uniqueId
                                                                  }
                                                                  data-index={
                                                                    index
                                                                  }
                                                                  onClick={
                                                                    handleRemoveClick
                                                                  }
                                                                  color="link"
                                                                >
                                                                  <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="10.332"
                                                                    height="10.329"
                                                                    viewBox="0 0 10.332 10.329"
                                                                  >
                                                                    <path
                                                                      id="Icon_ionic-ios-close"
                                                                      data-name="Icon ionic-ios-close"
                                                                      d="M17.675,16.453l3.69-3.69a.865.865,0,0,0-1.223-1.223l-3.69,3.69-3.69-3.69a.865.865,0,1,0-1.223,1.223l3.69,3.69-3.69,3.69a.865.865,0,1,0,1.223,1.223l3.69-3.69,3.69,3.69a.865.865,0,0,0,1.223-1.223Z"
                                                                      transform="translate(-11.285 -11.289)"
                                                                      fill="#7a7a7a"
                                                                    />
                                                                  </svg>
                                                                </Button>
                                                              )}
                                                            </div>
                                                          )
                                                        )}
                                                        {/*  */}

                                                        <div className="multiChoice">
                                                          <div className="addOption">
                                                            <Button
                                                              data-index={index}
                                                              data-uniqueid={
                                                                data.uniqueId
                                                              }
                                                              onClick={
                                                                handleAddClick
                                                              }
                                                              color="link"
                                                            >
                                                              Add Option
                                                            </Button>
                                                          </div>
                                                        </div>
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </Col>

                                                  <Col md="5">
                                                    <FormGroup>
                                                      <Input
                                                        type="select"
                                                        value={data.type}
                                                        data-uniqueid={
                                                          data.uniqueId
                                                        }
                                                        onChange={
                                                          FormInputChange
                                                        }
                                                        name="type"
                                                        id="exampleSelect"
                                                      >
                                                        {IntialType.map(
                                                          (type) => (
                                                            <option
                                                              value={type.value}
                                                            >
                                                              {type.type}
                                                            </option>
                                                          )
                                                        )}
                                                      </Input>
                                                    </FormGroup>
                                                    <FormGroup>
                                                      <Input
                                                        type="select"
                                                        value={
                                                          data.specialvalue
                                                        }
                                                        data-uniqueid={
                                                          data.uniqueId
                                                        }
                                                        onChange={
                                                          FormInputChange
                                                        }
                                                        name="specialvalue"
                                                        id="exampleSelect"
                                                      >
                                                        <option value="">
                                                          Select
                                                        </option>
                                                        {special.map((type) => (
                                                          <option
                                                            value={type.value}
                                                          >
                                                            {type.label}
                                                          </option>
                                                        ))}
                                                      </Input>
                                                    </FormGroup>
                                                  </Col>

                                                  <Col className="bottomAction">
                                                    <Button
                                                      data-uniqueid={
                                                        data.uniqueId
                                                      }
                                                      data-index={index}
                                                      onClick={AddDuplicate}
                                                      dat
                                                      color="link"
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16.218"
                                                        height="18.779"
                                                        viewBox="0 0 16.218 18.779"
                                                      >
                                                        <path
                                                          id="Icon_material-content-copy"
                                                          data-name="Icon material-content-copy"
                                                          d="M14.95,1.5H4.707A1.712,1.712,0,0,0,3,3.207v11.95H4.707V3.207H14.95Zm2.561,3.414H8.122A1.712,1.712,0,0,0,6.414,6.622v11.95a1.712,1.712,0,0,0,1.707,1.707h9.39a1.712,1.712,0,0,0,1.707-1.707V6.622A1.712,1.712,0,0,0,17.511,4.914Zm0,13.658H8.122V6.622h9.39Z"
                                                          transform="translate(-3 -1.5)"
                                                          fill="#7a7a7a"
                                                        />
                                                      </svg>
                                                    </Button>
                                                    {formValues.length === 1 ? (
                                                      ""
                                                    ) : (
                                                      <Button
                                                        data-uniqueid={
                                                          data.uniqueId
                                                        }
                                                        onClick={Delete}
                                                        color="link"
                                                      >
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="15.382"
                                                          height="19.777"
                                                          viewBox="0 0 15.382 19.777"
                                                        >
                                                          <path
                                                            id="Icon_material-delete"
                                                            data-name="Icon material-delete"
                                                            d="M8.6,22.079a2.2,2.2,0,0,0,2.2,2.2h8.79a2.2,2.2,0,0,0,2.2-2.2V8.895H8.6ZM22.882,5.6H19.036l-1.1-1.1H12.444l-1.1,1.1H7.5V7.8H22.882Z"
                                                            transform="translate(-7.5 -4.5)"
                                                            fill="#7a7a7a"
                                                          />
                                                        </svg>
                                                      </Button>
                                                    )}
                                                    <Input
                                                      className="ml-2"
                                                      checked={data.isMandatory}
                                                      data-uniqueid={
                                                        data.uniqueId
                                                      }
                                                      onChange={FormInputChange}
                                                      name="isMandatory"
                                                      value={data.isMandatory}
                                                      type="switch"
                                                      id={
                                                        "exampleCustomSwitch" +
                                                        data.uniqueId
                                                      }
                                                      label="Required"
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}
                                          </Draggable>
                                        ))}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    {provided.placeholder}

                                    <div className="licenseEditToolBtn mb-5">
                                      <Button
                                        color="primary"
                                        className="mr-2"
                                        disabled={DeleteAgency || tempSatatus}
                                        onClick={AddNew}
                                      >
                                        Add New
                                      </Button>
                                      <br/>
                                      <Button
                                        color="primary"
                                        className="mr-2"
                                        disabled={DeleteAgency || tempSatatus}
                                        type="submit"
                                      >
                                        {" "}
                                        {buttonLoading ? <Spinner /> : "Save"}
                                      </Button>
                                    </div>
                                  </Form>
                                </div>
                              )}
                            </Droppable>
                          </DragDropContext>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </TabPane>
            <TabPane tabId="2">
              <Card body className="mt-4">
                <CardTitle tag="h5">Additional Document List</CardTitle>
                <FormPreview
                  previewModal={previewModal}
                  requiredDoc={requiredDoc}
                  previewtoggle={previewtoggle}
                />
                <RequiredDocument
                  tempSatatus={tempSatatus}
                  requiredDoc={requiredDoc}
                  DeleteAgency={DeleteAgency}
                  sucesscallback={sucesscallback}
                  categoryId={categoryId}
                />
              </Card>
            </TabPane>
          </TabContent>
        </div>
      </Container>
    </div>
  );
}
